import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { normalizeLocale } from '@/utils/helpers';
import { sharedConfig } from '@/config/sharedConfig';

export const LANGUAGE_KEY = 'language';
function getInitialState() {
  if (typeof window == 'undefined') {
    return {
      language: sharedConfig.defaultLocale,
    };
  }

  return {
    language: localStorage.getItem(LANGUAGE_KEY)
      ? localStorage.getItem(LANGUAGE_KEY)
      : sharedConfig.defaultLocale,
  };
}

const languageSlice = createSlice({
  name: LANGUAGE_KEY,
  initialState: getInitialState(),
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      const locale = normalizeLocale(action.payload);
      state.language = locale;
      localStorage.setItem(LANGUAGE_KEY, locale);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
